document.addEventListener('DOMContentLoaded', function() {
    const brandSelect = document.getElementById('select_custom_brand');
    const modelSelect = document.getElementById('select_custom_model');
    const modelOptions = modelSelect.querySelectorAll('option[data-brand]');
    const selectedBrandInput = document.getElementById('selected_brand_input');
    const selectedModelInput = document.getElementById('selected_model_input');
    const addToCartButton = document.getElementById('ProductSubmitButton-');
    
    brandSelect.addEventListener('change', function() {
        const selectedBrand = this.value;
        brandSelect.querySelectorAll('option').forEach(option => {
            option.removeAttribute('selected');
        });
        brandSelect.querySelector(`option[value="${selectedBrand}"]`).setAttribute('selected', 'selected');
        
        modelSelect.innerHTML = '<option value="-1" class="choose_device" disabled>Select Model</option>';
        
        let firstModel = null;
        modelOptions.forEach(option => {
            if (option.getAttribute('data-brand') === selectedBrand) {
                const clonedOption = option.cloneNode(true);
                modelSelect.appendChild(clonedOption);
                if (!firstModel) {
                    firstModel = clonedOption;
                }
            }
        });

        if (modelSelect.children.length === 1) {
            modelSelect.innerHTML = '<option value="-1" disabled>No Models Available</option>';
        }

        selectedBrandInput.value = selectedBrand;

        // Auto-select the first model if available
        if (firstModel) {
            firstModel.setAttribute('selected', 'selected');
            selectedModelInput.value = firstModel.value;
        } else {
            selectedModelInput.value = "";
        }
    });

    modelSelect.addEventListener('change', function() {
        const selectedModel = this.value;
        modelSelect.querySelectorAll('option').forEach(option => {
            option.removeAttribute('selected');
        });
        modelSelect.querySelector(`option[value="${selectedModel}"]`).setAttribute('selected', 'selected');
        selectedModelInput.value = selectedModel;
    });

    addToCartButton?.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('form[data-type="add-to-cart-form"]').submit();
    });
});
